import React from 'react';
import { CircleAlert } from 'lucide-react';

/**
 * Error words beside a field or control, in brick with an icon so the colour
 * never carries the message alone.
 */
export function ErrorText({
  children,
  id,
  role,
  className,
}: {
  children: React.ReactNode;
  id?: string;
  role?: 'alert';
  className?: string;
}) {
  return (
    <p
      id={id}
      role={role}
      className={`flex items-start gap-1 text-destructive ${className ?? 'text-sm'}`}
    >
      <CircleAlert className="mt-px size-[1.1em] shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
